// src/api/skillService.ts
import api from './config';

export interface Skill {
  id?: number;
  name: string;
  category: string;
  proficiency: number;
  description?: string;
}

export const getSkills = async (): Promise<Skill[]> => {
  const response = await api.get('/api/skills');
  return response.data.data;
};

export const getSkillById = async (id: number): Promise<Skill> => {
  const response = await api.get(`/api/skills/${id}`);
  return response.data.data;
};

// Add CRUD operations for admin functionality
export const createSkill = async (skill: Omit<Skill, 'id'>): Promise<Skill> => {
  const response = await api.post('/api/skills', skill);
  return response.data.data;
};

export const updateSkill = async (id: number, skill: Partial<Skill>): Promise<Skill> => {
  const response = await api.put(`/api/skills/${id}`, skill);
  return response.data.data;
};

export const deleteSkill = async (id: number): Promise<void> => {
  await api.delete(`/api/skills/${id}`);
};
